import { Equipment } from '../objects/Equipment';

angular.module("tromanWeb").controller('PersonEquipmentController', ['tromanServer', 'dialogService', 'personState', function (tromanServer, dialogService, personState) {

    var self = this;

    function loadItems() {
        tromanServer.Equipment.search({
            PersonId: personState.person.Id
        }).then(function (data) {
            self.equipment = data;
        }).catch(function (err) {
            self.equipment = null;
            dialogService.error(err);
        });
    }

    self.edit = function edit(eq) {
        dialogService.editEquipment(eq).then(loadItems);
    };

    self.add = function add() {
        var toAdd = new Equipment();
        toAdd.Person = personState.person;
        dialogService.editEquipment(toAdd).then(loadItems);
    };

    self.canCreateList = function () {
        if (self.equipmentTable != null && self.equipmentTable.selectionCount > 0)
            return true;

        return false;
    };

    self.createList = function createList() {

        if (!self.canCreateList()) return;

        var selected = [];
        if (self.equipmentTable != null) {
            selected = self.equipmentTable.selectedItems();
        }

        dialogService.createEquipmentList(selected, 'Lista - Utrustning ( ' + personState.person.display + ' )');
    };

    loadItems();
}]);
